<template>
  <div class="task-detail">
    <div class="top-content">
      <svg-icon icon-class="dbg" class="top-bg"></svg-icon>
    </div>
    <div class="centent">
      <Row type="flex" justify="space-between">
        <i-col>
          <div class="tip">
            <span class="title">{{workInfo.workName}}</span>
            <span class="word">更新于：</span>
            <span class="time">{{workInfo.createTime}}</span>
          </div>
          <div class="detail">
            <img
              @click="toFriend(workInfo.userId)"
              :src="wechatInfo && wechatInfo.headimgurl || '/static/img/avatar.jpg'"
            />
            <span @click="toFriend(workInfo.userId)">{{workInfo.realname}}</span>
            <span>{{userInfo.attention}}关注</span>
            <span>作者排名：{{userDetail.userRank}}</span>
            <div class="share">
              <span>分享到</span>
              <Poptip trigger="hover" title content="content">
                <svg-icon icon-class="wxgray" v-show="showWx" @mouseover="showWx = false"></svg-icon>
                <svg-icon icon-class="wx1" v-show="!showWx" @mouseleave="showWx = true"></svg-icon>
                <div slot="content">
                  <qrcode-vue :value="getMobileLink()" :size="200" level="H"></qrcode-vue>
                </div>
              </Poptip>

              <a target="_blank" :href="qqShareUrl">
                <svg-icon icon-class="qqgray" v-show="showQQ" @mouseover="showQQ = false"></svg-icon>
                <svg-icon icon-class="qq" v-show="!showQQ" @mouseleave="showQQ = true"></svg-icon>
              </a>
              <a target="_blank" :href="sinaShareUrl">
                <svg-icon icon-class="wbgray" v-show="showWb" @mouseover="showWb = false"></svg-icon>
                <svg-icon icon-class="wb" v-show="!showWb" @mouseleave="showWb = true"></svg-icon>
              </a>
            </div>
          </div>
        </i-col>
        <i-col style="width: 310px">
          <Row class="mark" type="flex" align="middle">
            <i-col span="7" class="num">{{(workInfo.average || 0).toFixed(2)}}</i-col>
            <i-col span="17">
              <Rate
                v-model="workInfo.average"
                :disabled="true"
                style="font-size: 30px;font-weight: 700;"
              />
              <p class="grade">{{workInfo.scoreNum}}个评分</p>
            </i-col>
          </Row>
        </i-col>
      </Row>
      <Row type="flex" justify="space-between" style="">
        <i-col span="16" style="width: 700px; margin-top:30px;">
          <iframe
            :src="workInfo.workFileUrl?'/static/scratch3/player.html?projectURL=' + workInfo.workFileUrl:'about:blank'"
            id="player"
            frameborder="0"
            width="100%"
            height="100%"
            scrolling="no"
          ></iframe>
          <div class="catalog" v-if="workInfo.workTag">
            <div
              class="tag-wrap"
              v-for="(tag, index) in workInfo.workTag.split(',')"
              :key="index"
            >{{tag}}</div>
          </div>
          <div class="op">
            <div>
              <i style="font-size: 20px;" class="fa fa-thumbs-up" @click="starWork"></i>
              <span @click="starWork">{{workInfo.starNum}}</span>
            </div>
            <div>
              <i style="font-size: 20px;" class="fa fa-star" @click="collectWork"></i>
              <span @click="collectWork">{{isCollect?"取消收藏":"收藏"}}</span>
            </div>
            <div>
              <Poptip trigger="hover" title content="content">
                <i style="font-size: 20px;" class="fa fa-qrcode"></i>
                <span>用手机玩</span>
                <div slot="content">
                  <qrcode-vue :value="getMobileLink()" :size="200" level="H"></qrcode-vue>
                </div>
              </Poptip>
            </div>
            <div>
              评分
              <Rate v-model="workScore" @on-change="scoreWork" style="font-size: 20px;" />
            </div>
            <div>
              <i style="font-size: 20px;" class="fa fa-exclamation-triangle"></i>
              <span>举报</span>
            </div>
          </div>
          <div class="explain">
            <span>作品说明：</span>
            <p>{{workInfo.workDesc}}</p>
          </div>
          <div class="explain">
            <span>操作说明:</span>
            <p>{{workInfo.playDesc}}</p>
          </div>

          <div class="comment">
            <!-- <p class="col">收起</p> -->
            <div class="publish">
              <div class="tip">
                <span>发布评论</span> 文明上网理性发言，请遵守评论服务协议
              </div>
              <Row type="flex" justify="space-between">
                <i-col span="3" class="md-people">
                  <Icon type="md-person" class="people" />
                  <p>{{mineUserInfo && mineUserInfo.realname || '未登录'}}</p>
                </i-col>
                <i-col span="18" class="status">
                  <Input v-model="commentContent" type="textarea" :rows="4" placeholder />
                  <div class="login">
                    <span @click="comment">发表评论</span>
                  </div>
                </i-col>
              </Row>
              <Row type="flex" justify="space-between">
                <i-col class="all-com">
                  <span>全部评论</span>
                  {{comments && comments.length}}条
                </i-col>
                <i-col class="sel">
                  <span :class="isNew ? 'selected' : ''" @click="isNew = true">最新</span> /
                  <span :class="!isNew ? 'selected' : ''" @click="isNew=false">最热</span>
                </i-col>
              </Row>
            </div>
            <div class="comment-list">
              <ul>
                <li v-for="(item, index) in comments" :key="index">
                  <Row type="flex" align="middle" justify="space-between" class="item">
                    <i-col span="3" style="text-align: center">
                      <Icon type="md-person" class="people" />
                    </i-col>
                    <i-col span="18">
                      <div>
                        <span class="user">{{item.nickname}}</span>
                        <span class="time">{{item.createTime}}</span>
                      </div>
                      <p>{{item.comment}}</p>
                      <div>
                        <span @click="starComment(item)">
                          <i class="fa fa-thumbs-up"></i>
                          点赞 {{item.starNum}}
                        </span>
                        <span @click="replyComment(item)">
                          <i class="fa fa-comment"></i>
                          回复 {{item.replyNum}}
                        </span>
                      </div>
                    </i-col>
                    <i-col span="2">
                      <i class="fa fa-exclamation-triangle"></i> 举报
                    </i-col>
                  </Row>
                </li>
              </ul>
              <div class="more">
                <span @click="more">
                  <span>{{nomore?"已加载全部":"加载更多"}}</span>
                  <Icon type="md-arrow-down" />
                </span>
              </div>
            </div>
          </div>
        </i-col>
        <i-col span="8">
          <div style="min-heigth: 700px;">
            <Card class="card" style="height:550px">
              <p class="title">推荐课程</p>
              <List class="list">
                <ListItem v-for="(item, index) in activityList" :key="index">
                  <div @click="toGoodsDetail(item.id)">
                    <ListItemMeta :avatar="item.activityCoverFileUrl" :title="item.activityName" />
                    <span class="price">￥{{item.price / 100}}</span>
                  </div>
                </ListItem>
              </List>
            </Card>
          </div>
          <div class="btns">
            <span v-if="mineUserInfo && mineUserInfo.id && this.workInfo.editable">
              <a
                :href="'/static/scratch3/index.html?scene=create&workId=' + this.workId"
                target="_blank"
              >改编作品</a>
            </span>
            <span>
              <a href="/static/scratch3/index.html?scene=create" target="_blank">创作新作品</a>
            </span>
          </div>
          <div class="good-task">
            <span class="hot">同类热门</span>
            <Row type="flex" justify="space-between">
              <i-col
                span="11"
                class="card-list"
                v-for="(item, index) in workRankResult.records"
                :key="index"
              >
                <Card :shadow="true" class="card">
                  <div class="pic" @click="toDetail(item.id)">
                    <img :src="item.coverFileUrl" alt />
                  </div>
                  <div class="card-content">
                    <p class="title" @click="toDetail(item.id)">{{item.workName}}</p>
                    <Row type="flex" justify="space-between" style="margin: 10px 0">
                      <i-col span="8">初学者</i-col>
                      <i-col span="6">scratch</i-col>
                    </Row>

                    <p class="num">
                      <span>
                        <i class="fa fa-thumbs-up"></i>
                        {{item.starNum}}
                      </span>
                      <span>
                        <i class="fa fa-comment-o"></i>
                        {{item.commentNum}}
                      </span>
                      <span>
                        <i class="fa fa-eye"></i>
                        {{item.viewNum}}
                      </span>
                    </p>
                  </div>
                  <Row type="flex" align="middle" justify="center" class="footer">
                    <i-col>
                      <span class="fa fa-user q"></span>
                      <span>{{item.realname}}</span>
                    </i-col>
                  </Row>
                </Card>
              </i-col>
            </Row>
          </div>
          <div class="rank">
            <div class="share-more">
              <span>分享</span>
              <span>更多</span>
            </div>
            <div class="top-rank">
              <p>金币排行榜</p>
              <div>
                你的金币:
                <span>{{mineInfo.integral}}</span>位列金币榜第
                <span>{{mineRank}}</span>名
              </div>
            </div>
            <ul>
              <li v-for="(item, index) in userRankList" :key="index">
                <Row type="flex" justify="space-between">
                  <i-col span="3">
                    <span class="index">{{index + 1}}</span>
                  </i-col>
                  <i-col span="3">
                    <img
                      v-if="item.headimgurl"
                      :src="item.headimgurl"
                      alt
                      style="width:30px;position: relative;top: 10px;"
                    />
                    <Icon v-else type="md-person" />
                  </i-col>
                  <i-col span="10">{{item.realname}}</i-col>
                  <i-col span="3">{{item.integral}}</i-col>
                </Row>
              </li>
            </ul>
          </div>
        </i-col>
      </Row>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@/utils/auth";
import {
  getWorkRank,
  workInfo,
  getUserDetail,
  commentWork,
  workComments,
  starComment,
  scoreWork,
  isCollectWork,
  collectWork,
  starWork,
  communityCattle,
} from "@/api/community";
import QrcodeVue from "qrcode.vue";
import { getActivityList } from "@/api/buy";
export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      isCollect: false,
      workScore: 0,
      showWx: true,
      showQQ: true,
      showWb: true,
      imgUrl: require("../../assets/task/u359.png"),
      textVal: "",
      workId: "",
      workInfo: {},
      comments: [],
      commentContent: "",
      replyCommentId: null,
      userDetail: { userInfo: {}, wechatInfo: {} },
      userInfo: {},
      wechatInfo: {},
      mineUserInfo: {},
      activityList: [],
      isNew: true, // 最新、最热
      workRankResult: {},
      list: [{}],
      commentspage: 1,
      nomore: false, //是否有更多评论
      qqShareUrl: "",
      sinaShareUrl: "",
      mineInfo: {},
      mineRank: 0,
      userRankList: [],
    };
  },
  mounted() {
    this.workId = this.$route.query.workId;
    console.log(this.workId);
    this.getWorkRank("year", "star");
    this.getWorkInfo(this.workId);
    this.getActivityList();
    this.communityCattle();
    this.mineUserInfo = JSON.parse(getUserInfo());
    if (this.mineUserInfo) {
      this.isCollectWork();
      getUserDetail(this.mineUserInfo.id).then((res) => {
        if (res.success) {
          this.mineRank = res.result.userRank;
          this.mineInfo = res.result.userInfo;
        }
      });
    }
    var that = this;
    //scratch全屏
    document.addEventListener("scratchFullScreen", function (e) {
      that.launchIntoFullscreen(document.getElementById("player"));
    });
    //scratch退出全屏
    document.addEventListener("scratchUnFullScreen", function (e) {
      that.exitFullscreen();
    });

    document.addEventListener("scratchInit", function(e){
      var p = document.getElementById("player");
      var s = p.contentDocument.getElementById("scratch");
      s.addEventListener("click", () => {
        p.focus();
      });
    })
    //scratch获取焦点
    
  },
  created() {},
  methods: {
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen();
      }
    },
    getActivityList() {
      getActivityList("", "", "", 2, 5).then((res) => {
        this.activityList = res.result;
      });
    },
    communityCattle() {
      communityCattle("integral", 1, 10).then((res) => {
        if (res.success) {
          this.userRankList = res.result.records;
        }
      });
    },
    starWork() {
      starWork(this.workId).then((res) => {
        if (res.success) {
          if (res.message == "点赞成功") {
            this.workInfo.starNum += 1;
          }
          this.$Message.success(res.message);
        }
      });
    },
    isCollectWork() {
      isCollectWork(this.workId).then((res) => {
        this.isCollect = res.success;
      });
    },
    collectWork() {
      collectWork(this.workId).then((res) => {
        if (res.success) {
          if (res.message == "收藏成功") {
            this.isCollect = true;
          } else {
            this.isCollect = false;
          }
          this.$Message.success(res.message);
        }
      });
    },
    starComment(item) {
      starComment(item.id).then((res) => {
        this.$Message.success(res.message);
        if (res.success) {
          this.commentContent = "";
          // this.workComments();
          if (res.message == "点赞成功") {
            item.starNum = item.starNum + 1;
          }
        }
      });
    },
    //获取作品信息
    getWorkInfo(workId) {
      workInfo(workId).then((res) => {
        if (res.success) {
          this.workInfo = res.result;
          this.qqShareUrl =
            "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
            encodeURIComponent(document.location.href) +
            "&sharesource=qzone&title=" +
            encodeURIComponent(this.workInfo.workName) +
            "&pics=" + 
            encodeURIComponent("http:"+this.workInfo.coverFileUrl) +
            "&summary=我做了好玩的编程作品，快来看看吧";
          this.sinaShareUrl =
            "http://service.weibo.com/share/share.php?url=" +
            document.location.href +
            "?sharesource=weibo&title=我的新作品：" +
            this.workInfo.workName +
            "&pic=" +
            encodeURIComponent(this.workInfo.coverFileUrl) +
            "&appkey=70876773";
          console.log(this.qqShareUrl);
          getUserDetail(this.workInfo.userId).then((res) => {
            this.userDetail = res.result;
            this.userInfo = res.result.userInfo;
            this.wechatInfo = res.result.wechatInfo;
          });
          this.workComments();
        }
      });
    },
    more() {
      this.workComments(this.commentspage + 1);
    },
    workComments(page) {
      console.log(page);
      workComments(this.workId, page || 1).then((res) => {
        if (res.result.length == 0) {
          this.nomore = true;
        } else {
          this.commentspage = page || 1;
          this.comments = this.comments.concat(res.result);
          // this.comments = {...this.comments, ...res.result};
        }
      });
    },
    comment() {
      if (this.commentContent != "") {
        commentWork(this.workId, this.replyCommentId, this.commentContent).then(
          (res) => {
            if (res.success) {
              this.commentContent = "";
              this.replyCommentId = null;
              this.comments.unshift(res.result);
            }
            // this.workComments();
          }
        );
      }
    },
    replyComment(item) {
      this.commentContent = "回复 " + item.createBy + ":";
      this.replyCommentId = item.id;
      // commentWork(this.workId, null, this.commentContent).then(res => {
      //   this.workComments();
      // });
    },
    toDetail(workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`,
      });
      this.getWorkInfo(workId);
      //window.location.href = "/task-detail?workId="+workId
    },
    toFriend(userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`,
      });
    },
    getMobileLink() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/static/scratch3/work.html?workId=" +
        this.workId
      );
    },
    scoreWork(v) {
      console.log(v);
      scoreWork(this.workId, this.workScore).then((res) => {
        if (res.success) {
          if (res.message == "评分成功") {
            this.workInfo.scoreNum += 1;
          }
          this.$Message.success(res.message);
        }
      });
    },
    //作品排行榜 cycle:week|year
    getWorkRank(cycle) {
      this.workRankType = cycle;
      getWorkRank(cycle, "time", 1, 8).then((res) => {
        console.log(res);
        if (res.success) {
          this.workRankResult = res.result;
        }
      });
    },
    toGoodsDetail(actId) {
      console.log(11);
      this.$router.push({
        path: `/goodsDetail?actId=${actId}`,
      });
    },
  },
};
</script>
<style lang="scss">
.task-detail {
  .ivu-rate {
    font-size: 30px;
    font-weight: 700;
  }
  .card {
    .ivu-card-body {
      padding: 20px;
    }
  }
  .list {
    .ivu-list-item {
      position: relative;
      padding: 7px 0;
      border: none;
      .ivu-list-item-meta-title {
        color: #666;
        font-size: 16px;
        font-weight: 700;
        padding-top: 14px;
      }

      .ivu-avatar {
        width: 112px;
        height: 70px;
        img {
          width: 112px;
          border-radius: 8px;
        }
        border-radius: unset;
      }
    }
  }
  .explain-content {
    .ivu-poptip-popper {
      text-align: left;
    }
  }
  .card-list .ivu-card-shadow {
    box-shadow: 0px 0px 5px rgba(14, 118, 161, 0.407843137254902);
    .ivu-card-body {
      padding: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.task-detail {
  background: #fff;
  position: relative;
  .top-content {
    width: 100%;
    overflow-x: hidden;
    height: 751px;
    margin-top: -90px;
    padding-top: 100px;
    position: absolute;
    background: linear-gradient(
      0deg,
      rgb(72, 198, 239) -4%,
      rgb(111, 134, 214) 82%
    );
    .top-bg {
      width: 2432px;
      height: 104px;
      position: absolute;
      left: -380px;
      bottom: 0;
    }
  }
  .centent {
    text-align: left;
    background: #fff;
    border-radius: 20px;
    width: 1200px;
    margin: 20px auto 0;
    padding: 50px;
    position: relative;
    .tip {
      .title {
        color: #333;
        font-size: 20px;
        font-weight: 700;
        margin-right: 55px;
      }
      .word {
        color: #333;
      }
      .time {
        font-family: "微软雅黑", sans-serif;
        color: #555;
        font-size: 13px;
      }
    }
    .detail {
      color: #027db4;
      margin-top: 20px;
      font-size: 13px;
      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
        margin-right: 5px;
      }
      span {
        vertical-align: middle;
        margin-right: 50px;
      }
      .share {
        margin-left: 60px;
        display: inline-block;
        position: relative;
        span {
          margin-right: 10px;
          font-size: 16px;
          color: #333;
          vertical-align: middle;
        }
        svg {
          width: 36px;
          height: 20px;
          margin-left: 10px;
          vertical-align: middle;
        }
        img {
          position: absolute;
          z-index: 999;
        }
        .wxshare {
          width: 100px;
          top: 40px;
          left: 70px;
          box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        }
        .wbshare {
          width: 790px;
          top: 50%;
          left: 50%;
          transform: translate(-100%, -27%);
        }
        .qqshare {
          width: 800px;
          top: 50%;
          left: 20%;
          transform: translate(-87%, -20%);
        }
      }
    }
    .mark {
      .num {
        font-size: 30px;
        color: #f59a23;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
      }
      .grade {
        font-weight: 400;
        color: #333;
        font-size: 20px;
      }
    }
    iframe {
      width: 700px;
      height: 600px;
    }
    .catalog {
      color: #027db4;
      div {
        display: inline;
        border-radius: 50px;
        background: #f2f2f2;
        margin: 0 10px;
        padding: 5px 10px;
        font-size: 14px;
      }
      span {
        vertical-align: middle;
        margin-right: 50px;
      }
    }
    .op {
      margin: 25px 0;
      color: #027db4;
      font-size: 14px;
      div {
        display: inline;
      }
      span {
        vertical-align: middle;
        margin-right: 50px;
      }
    }
    .explain {
      color: #6e6e6e;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 26px;
      span {
        color: #3c3b3b;
        font-weight: 700;
      }
    }
    .card {
      margin-top: 30px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
      border: none;
      color: #666;
      .list {
        background: #fff;
        border-radius: 10px;
        .price {
          font-size: 15px;
          color: #999;
          position: absolute;
          left: 130px;
          bottom: 20px;
        }
      }
      .title {
        font-size: 18px;
        font-weight: 700;
        line-height: 40px;
        margin-bottom: 8px;
      }
    }

    .btns {
      margin-top: 30px;
      span {
        display: inline-block;
        width: 144px;
        height: 50px;
        line-height: 50px;
        border-radius: 50px;
        text-align: center;
        color: #fff;
        font-size: 20px;
        background: rgba(245, 154, 35, 1);
        &:first-child {
          margin-right: 60px;
        }
      }
    }

    .comment {
      .col {
        font-weight: 400;
        color: #2aa1d4;
        font-size: 16px;
      }
      .publish {
        margin-top: 20px;
        padding: 20px;
        border: 1px solid rgb(233, 233, 233);
        .tip {
          color: #ccc;
          font-weight: 400;
          font-size: 12px;
          margin-bottom: 20px;
          span {
            color: #666;
            font-weight: 700;
            font-size: 14px;
          }
        }
        .md-people {
          text-align: center;
          padding-top: 20px;
          p {
            margin-top: 10px;
            color: #999;
            font-weight: 400;
            font-size: 12px;
          }
          .people {
            font-size: 30px;
            color: #666;
          }
        }
        .status {
          .login {
            background: rgba(242, 242, 242, 1);
            padding: 10px;
            text-align: right;
            span {
              border: 1px solid rgba(228, 228, 228, 1);
              background: #fff;
              color: #999;
              display: inline-block;
              height: 40px;
              line-height: 40px;
              width: 100px;
              text-align: center;
              cursor: pointer;
              &:hover {
                color: cornflowerblue;
              }
            }
          }
        }
        .explain-content {
          text-align: right;
          .number {
            padding: 0px 4px;
            color: #000;
            background-color: #fff849;
            box-shadow: 1px 1px 3px #aaa;
          }
        }
        .explain-word {
          .word {
            background: #fff849;
            padding: 0 4px;
            line-height: 20px;
          }
          .return {
            font-size: 13px;
            font-weight: 600;
            color: #58167d;
          }
          span {
            display: block;
            font-weight: 700;
            margin: 10px 0;
          }
        }
        .all-com {
          margin-top: 20px;
          span {
            font-weight: 700;
          }
        }
        .sel {
          margin-top: 20px;
          font-size: 12px;
          color: #999;
          .selected {
            color: #666;
          }
        }
      }
      .comment-list {
        color: #999;
        border: 1px solid #e9e9e9;
        border-top: none;
        padding: 0 20px;
        .item {
          padding: 20px;
          font-size: 13px;
          border-bottom: 1px solid #e9e9e9;
          .people {
            font-size: 30px;
          }
          .user {
            color: #666;
            font-size: 14px;
            margin-right: 5px;
          }
          .time {
            font-size: 12px;
          }
          span {
            margin-right: 30px;
          }
          p {
            margin: 10px 0;
          }
        }
        .more {
          font-size: 13px;
          text-align: center;
          padding-top: 40px;
          padding-bottom: 20px;
          > span {
            border: 1px solid #e9e9e9;
            line-height: 47px;
            width: 140px;
            height: 47px;
            display: inline-block;
            color: #999;
          }
        }
      }
    }

    .good-task {
      margin-top: 50px;
      .hot {
        background: rgba(57, 165, 239, 1);
        color: #fff;
        border-radius: 10px;
        display: inline-block;
        padding: 2px 10px;
        font-size: 12px;
      }
      .card-list {
        margin-right: 30px;
        margin-bottom: 20px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .card {
          width: 180px;
          text-align: left;
          color: #999;
          .pic {
            width: 100%;
            height: 129px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              transition: all 0.2s ease-out;
              &:hover {
                transform: scale(1.05);
              }
            }
          }
          .card-content {
            padding: 8px 20px;
            font-size: 14px;
            .title {
              color: #666;
              font-size: 16px;
              font-weight: bold;
            }
            .num {
              font-size: 12px;
              span {
                margin-right: 5px;
              }
            }
          }
          .footer {
            padding: 4px 20px;
            font-size: 12px;
            padding-bottom: 10px;
            .q {
              background: #ccc;
              border-radius: 50%;
              padding: 2px 6px;
              color: #fff;
              width: 26px;
              height: 26px;
              font-size: 20px;
              line-height: 20px;
            }
          }
        }
      }
    }
    .rank {
      margin-top: 30px;
      position: relative;
      .share-more {
        position: absolute;
        right: 10px;
        top: 25px;
        color: #fff;
        span {
          margin-right: 10px;
        }
      }
      .top-rank {
        padding: 10px 20px;
        background: rgba(45, 128, 188, 1);
        color: #fff;
        p {
          font-size: 16px;
          font-weight: 700;
        }
        span {
          font-weight: 700;
          color: #f5e323;
        }
      }
      ul {
        color: #999;
        text-align: center;
        border-left: 1px solid #e9e9e9;
        border-right: 1px solid #e9e9e9;
        li {
          padding: 0 20px;
          line-height: 54px;
          border-bottom: 1px solid #e9e9e9;
          .index {
            background: #ccc;
            color: #fff;
            font-weight: 700;
            font-size: 16px;
            display: inline-block;
            padding: 3px 8px;
            line-height: 13px;
            border-radius: 20px;
          }
          &:first-child .index,
          &:nth-child(2) .index,
          &:nth-child(3) .index {
            background: #f95e5a;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/taskDetail.vue